export const enum PropertyKeyAccessType {
  Code = 'code',
  Remote = 'remote',
  Physical = 'physical',
  Unknown = 'unknown'
}

export const enum PropertyKeyType {
  PropertyElevatorDoor = 'elevator-door',
  PropertyEntrance = 'entrance',
  PropertyHallway = 'hallway',
  PropertyKitchen = 'kitchen',
  PropertyLuggage = 'luggage',
  PropertyUnit = 'unit',
  PropertyWashateria = 'washateria',
  Unknown = 'unknown'
}
interface PropertyKeyBaseModel {
  readonly id: string;
  readonly name: string;
  readonly type: PropertyKeyType;
  readonly sequenceNumber: number;
  readonly validFromDate: string;
  readonly validToDate: string;
  readonly deletedAt: string | null;
}

export interface PropertyKeyCodeModel extends PropertyKeyBaseModel {
  readonly accessType: PropertyKeyAccessType.Code | null;
  readonly code: string | null;
}

export interface PropertyKeyRemoteModel extends PropertyKeyBaseModel {
  readonly accessType: PropertyKeyAccessType.Remote | null;
}

export interface PropertyKeyPhysicalModel extends PropertyKeyBaseModel {
  readonly accessType: PropertyKeyAccessType.Physical | null;
}

export type PropertyKeyModel =
  PropertyKeyCodeModel |
  PropertyKeyRemoteModel |
  PropertyKeyPhysicalModel;
